export default {"src":"/_next/static/media/de-flag.4f441a89.svg","height":600,"width":1000,"blurWidth":0,"blurHeight":0};